import styled from 'styled-components';

// --- STYLED COMPONENTS ---

// Highlights of this Styling Setup:
// styled(Input).attrs({ as: 'textarea' }): Reuses all border, outline, padding, and font styles from <Input> directly for the <textarea> to keep your CSS DRY.

// Transient Props ($error): Uses styled-components' $prefix for transient props so $error is not passed down to the underlying DOM node (preventing React unknown attribute warnings).

// CSS Variables Support: Uses fallback variables (var(--primary-color, #111111)), making it easy to seamlessly inherit your blog’s global color theme or dark mode setup if you use CSS custom properties.

// Submitting State: Disables the submit button and changes the text to "Sending..." during active submission.

export const Title = styled.div`
	text-align: center;
`;

export const FormWrapper = styled.div`
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
`;

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Label = styled.label`
	font-size: 0.95rem;
	font-weight: 600;
	color: #f9fafb;
`;

export const Input = styled.input`
	background-color: #1e2d2b; /* Slightly lighter than the card */
	border: 1px solid #2e4642; /* Clean, visible border */
	color: var(--color);
	padding: 0.75rem 1rem;
	border-radius: 6px;
	width: 100%;
	font-family: inherit;
	font-size: 1rem;
	transition:
		border-color 0.2s ease,
		box-shadow 0.2s ease;

	&:focus {
		outline: none;
		border-color: #06b6d4; /* Or your preferred highlight color */
		box-shadow: 0 0 8px rgba(6, 182, 212, 0.2);
		background-color: #233532;
	}
`;

export const TextArea = styled(Input).attrs({ as: 'textarea' })`
	min-height: 140px;
	resize: vertical;
`;

export const SubmitButton = styled.button`
	padding: 0.85rem 1.5rem;
	font-size: 1rem;
	font-weight: 600;
	font-family: inherit;
	color: var(--color);
	background-color: var(--primary-color, #06b6d4);
	border: none;
	border-radius: 6px;
	cursor: pointer;
	transition:
		background-color 0.2s ease,
		transform 0.1s ease;

	&:hover {
		background-color: var(--primary-hover, #22d3ee);
	}

	&:active {
		transform: scale(0.98);
	}

	&:disabled {
		background-color: #a0a0a0;
		cursor: not-allowed;
	}
`;

export const MessageBanner = styled.div`
	padding: 1rem 1.25rem;
	border-radius: 6px;
	font-size: 0.95rem;
	line-height: 1.5;
	background-color: ${props => (props.$error ? '#fde8e8' : '#e6f4ea')};
	color: ${props => (props.$error ? '#c5221f' : '#137333')};
	border: 1px solid ${props => (props.$error ? '#f8b4b4' : '#a8dab5')};

	h3 {
		margin: 0 0 0.25rem 0;
		font-size: 1.1rem;
	}

	p {
		margin: 0;
	}
`;

export const HiddenHoneypot = styled.p`
	display: none;
`;
